import { Box, Theme, Typography } from "@outschool/backpack";
import { FeaturedTeacherCard_LeaderFragment } from "@outschool/gql-frontend-generated";
import React from "react";

import { default as FeaturedTeacherCard } from "./FeaturedTeacherCard";

function FeaturedTeacherRow(
  {
    teachers,
    title,
  }: { teachers: FeaturedTeacherCard_LeaderFragment[]; title: string },
  ref: React.Ref<any>
) {
  if (!teachers || !teachers.length) {
    return null;
  }

  const teacherElements = teachers.map(teacher => (
    <FeaturedTeacherCard
      leader={teacher}
      key={`popular-teacher-${teacher.uid}`}
    />
  ));
  return (
    <Box
      ref={ref}
      sx={(theme: Theme) => ({
        paddingY: "3em",

        [theme.breakpoints.up("md")]: {
          paddingY: "6em",
        },

        paddingX: "1em",
        textAlign: "center",
      })}
    >
      <Typography
        variant="h2"
        sx={(theme: Theme) => ({
          marginBottom: "1em",

          [theme.breakpoints.up("md")]: {
            marginBottom: "2em",
          },
        })}
      >
        {title}
      </Typography>
      <Box
        sx={(theme: Theme) => ({
          display: "grid",
          margin: "1em auto",
          gridTemplateColumns: "1fr 1fr",

          [theme.breakpoints.up("md")]: {
            gridTemplateColumns: "1fr 1fr 1fr 1fr",
          },

          gap: "1em",
          maxWidth: "1024px",
        })}
      >
        {teacherElements}
      </Box>
    </Box>
  );
}

export default React.forwardRef(FeaturedTeacherRow);
